/** ***********************************************************************
 * The IFramePostMessage is the message object to be passed between
 * the partner's parent webpage and the embedded bPerx iFrame.
 *
 * This IFramePostMessage will contain a MESSAGE TYPE (one
 * of the enum values available in this file) and a value in one of
 * the fields of this type.
 *
 * Upon receiving a post message, both the partner (through bperx.js)
 * and the iFrame should check the message type and act accordingly.
 *
 * @file   This file defines the IFramePostMessage type.
 * @author Paul J Stales
 * @since  2.0.0
 *********************************************************************** */

/**
 * IFramePostMessage type, generic message for partner-iframe communication.
 */
export interface IFramePostMessage {
  origin: string
  messageType: IFramePostMessageType
  iFrameLocalStorageKey: string
  payload: any
}

/**
 * IFramePostMessage type, used to determine the type of the iFrame post message
 */
export enum IFramePostMessageType {
  PARTNER_INFO_REQUEST,
  PARTNER_INFO_RESPONSE,
  TRANSACTION_INFORMATION_REQUEST,
  TRANSACTION_INFORMATION_RESPONSE,
  TRANSACTION_INFORMATION_UPDATE,
  TRANSACTION_INFORMATION_DELETE,
  IFRAME_HEIGHT_UPDATE,
  IFRAME_DIGITAL_LINK_SEND,
  REPORTABLE_EVENT
}
